import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { CommonService } from 'src/app/shared/common.service';
import { HTTPStatus } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { ServiceRequestService } from 'src/app/shared/service-request.service';
// import { analyzeAndValidateNgModules } from '@angular/compiler';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  pageid: string;
  data: any;
}
@Component({
  selector: 'app-search-view',
  templateUrl: './search-view.component.html',
  styleUrls: ['./search-view.component.scss']
})

export class SearchViewComponent implements OnInit {
  public addmore: UntypedFormGroup;
  MultiFilterList: any;
  MultiFilterArrayList: Array<any> = [];
  FilterContainValuesList: any;
  resultArray: Array<any> = [];
  constructor(private _fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) public _dialogData: DialogData, private _data: CommonService, private status: HTTPStatus, private error: AppErrorHandler,
    private _serviceRequestService: ServiceRequestService,
    private dialogRef: MatDialogRef<SearchViewComponent>) { }

  ngOnInit() {
    this.addmore = this._fb.group({
      PageID: [this._dialogData.pageid],
      FilterList: this._fb.array([])
    });


    this.BindMultipleFilter(this._dialogData.pageid);
    //this.GetFilterContainValues();
  }

  get formArr() {
    return this.addmore.get('FilterList') as UntypedFormArray;
  }
  onNoClick(): void {
    this.dialogRef.close(this.addmore);
  }

  getsearchRecord() {
    if (this._dialogData.data != undefined) {
      if (this._dialogData.data.FilterList != undefined) {
        if (this._dialogData.data.FilterList.length > 0) {

          this._dialogData.data.FilterList.forEach((element, index) => {
            if (element.FilterColumnsOriginal != "") {
              this.formArr.push(this.initItemRows());
              this.MultiFilterArrayList[index] = this.MultiFilterList;
              this.resultArray[index] = this.FilterContainValuesList.filter(x => x.DataType === element.DataType)
              const myForm = (<UntypedFormArray>this.addmore.get("FilterList")).at(index);
              myForm.patchValue({
                FilterColumnsID: element.FilterColumnsID,
                SearchText: element.SearchText,
                FilterColumnsDisplay: element.FilterColumnsDisplay,
                FilterColumnsOriginal: element.FilterColumnsOriginal,
                FilterContainValues: element.FilterContainValues,
                FilterContainDisplayText: element.FilterContainDisplayText,
                Operators: element.Operators,
                DataType: element.DataType,
                ParameterName: element.ParameterName  //added by anvesh mishra for SCTASK3638694 , SCTASK3635396-->
              });
              // row.controls.FilterColumnsID.setValue(element.FilterColumnsID);
              // row.controls.FilterColumnsDisplay.setValue(element.FilterColumnsDisplay);
              // row.controls.FilterColumnsOriginal.setValue(element.FilterColumnsOriginal);
              // row.controls.FilterContainValues.setValue(element.FilterContainValues);
              // row.controls.FilterContainDisplayText.setValue(element.FilterContainDisplayText);
              // row.controls.Operators.setValue(element.Operators);
              // row.controls.DataType.setValue(element.DataType);
              // row.controls.SearchText.setValue(element.SearchText);
              // this.formArr.push(row); 

              //this.formArr.push(element);
            }
          });

        }
        else {
          this.formArr.push(this.initItemRows());
        }

      }
      else {
        this.formArr.push(this.initItemRows());
      }
    }
    else {
      this.formArr.push(this.initItemRows());
    }
  }
  initItemRows() {
    return this._fb.group({
      FilterColumnsID: ['', Validators.required],
      FilterColumnsDisplay: [''],
      FilterColumnsOriginal: [''],
      FilterContainValues: ['', Validators.required],
      FilterContainDisplayText: [''],
      Operators: [''],
      DataType: [''],
      ParameterName: [''],
      SearchText: ['', Validators.required]
    });
  }
  addNewRow(i: number) {


    this.formArr.push(this.initItemRows());
    this.MultiFilterArrayList[i + 1] = this.MultiFilterList;
  }

  deleteRow(index: number) {
    this.formArr.removeAt(index);
  }
  BindMultipleFilter(pageid) {
    this._data.GetMultipleFilterColumns(pageid).subscribe(result => {
      this.MultiFilterList = result;
      this.MultiFilterArrayList.push(this.MultiFilterList);
    }, (error) => {
      // this.status.setHttpStatus(false);

      this.error.handleError(error);
    }, () => {
      // this.spinnerService.hide();
      this.GetFilterContainValues()
      // this.status.setHttpStatus(false); 
    });
  }

  ChangeDataTypeINList(e, index) {

    const singleList = this.MultiFilterArrayList[index].filter(x => x.value === e.value);
    const FilterColumnsList = this.addmore.get("FilterList").value;
    const count = FilterColumnsList.filter(x => x.FilterColumnsID === e.value);
    this.resultArray[index] = this.FilterContainValuesList.filter(x => x.DataType === singleList[0].DataType)
    const myForm = (<UntypedFormArray>this.addmore.get("FilterList")).at(index);
    if (count.length > 1) {
      myForm.patchValue({
        FilterColumnsID: "",
      });
      alert("duplicate value");
    }
    else {
      myForm.patchValue({
        FilterColumnsOriginal: singleList[0].FilterColumnsOriginal,
        DataType: singleList[0].DataTYpe,
        ParameterName: singleList[0].ParameterName,
        FilterColumnsDisplay: singleList[0].FilterColumnsDisplay
      });
    }
  }

  ChangeFilterContainValue(e, index) {

    const singleList = this.FilterContainValuesList.filter(x => x.value === e.value);

    const myForm = (<UntypedFormArray>this.addmore.get("FilterList")).at(index);
    myForm.patchValue({
      FilterContainDisplayText: singleList[0].FilterContainDisplayText,
      Operators: "AND",
    });

  }


  GetFilterContainValues() {

    this._data.GetFilterContainValues().subscribe(result => {
      this.FilterContainValuesList = result;
      this.resultArray.push(this.FilterContainValuesList);
    }, (error) => {
      // this.status.setHttpStatus(false);
      this.error.handleError(error);
    }, () => {
      // this.spinnerService.hide();
      this.getsearchRecord();
      // this.status.setHttpStatus(false); 
    });
  };

  // ResetAndGetResult(){
  //   debugger
  //   this.status.setHttpStatus(true);
  //   this.dialogRef.close(this.addmore);

  // }
  GetFormControls(controlName, index: any) {


    var formControl = this.addmore.controls.FilterList['controls'] as UntypedFormGroup;
    return formControl[index].controls[controlName];

  }
  showErrorsOnInvalidForm(formControl: UntypedFormGroup) {

    Object.keys(formControl[0].controls).forEach(field => {
      const control = formControl[0].get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  GetResult() {

    var formControl = this.addmore.controls.FilterList['controls'] as UntypedFormGroup;

    if (!formControl[0].valid) {
      alert('Please fill mandatory fields.');
      this.showErrorsOnInvalidForm(formControl);
      return false;
    }
    else {
      this.status.setHttpStatus(true);
      this.dialogRef.close(this.addmore);
    }
    // this._serviceRequestService.GetAllServiceRequest(this.addmore.value).subscribe(data => {
    //   

    //   if (data.RequestIsSuccess) {
    //     if (data.RequestEntityId !== null) {

    //     }
    //   }
    // })
  };

  SaveFilterDetail() {

    this.status.setHttpStatus(true);

    this._serviceRequestService.SaveFilterDetail(this.addmore.value).subscribe(data => {
      this.dialogRef.close(this.addmore);

    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }
}